<template>
  <div class="index">
    <el-container style="height: 100%">
      <el-container>
        <mymenu />
        <el-main>
          <div class="sill"></div>
          <div class="flex-x-center">
            <div class="con-register">
              <el-menu
                :default-active="activeIndex"
                active-text-color="#b8000d"
                class="el-menu-demo flex-between"
                mode="horizontal"
                router
              >
                <el-menu-item
                  class="title-fontsize flex-y-center"
                  @click="routeHop('/project')"
                  index="/project"
                  ><span
                    class="applyicon-fontsize iconfont icon-TAyewubanli"
                  ></span>
                  考试报名</el-menu-item
                >
                <div class="sill-t"></div>

                <el-menu-item
                  @click="routeHop('/mall')"
                  class="title-fontsize flex-y-center"
                  index="/mall"
                >
                  <span
                    style="margin-right: 4px"
                    class="icon-fontsize iconfont icon-shangcheng1"
                  ></span
                  >书籍订购
                </el-menu-item>
                <div class="sill-t"></div>
                <el-menu-item
                  class="title-fontsize flex-y-center"
                  @click="routeHop('/home')"
                  index="/home"
                >
                  <span
                    style="margin-right: 4px"
                    class="icon-fontsize k iconfont icon-wode"
                  ></span
                  >我的资料
                </el-menu-item>
              </el-menu>

              <router-view></router-view>
            </div>
          </div>
        </el-main>

        <el-footer>
          <bottommenu />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  watch: {
    $route(v) {
      this.activeIndex = v.path;
    },
  },
  data() {
    return {
      activeIndex: "0",
      activeIndexTwo: "1",
      radio: "1",
    };
  },
  mounted() {
    this.activeIndex = this.$route.path;
    // this.activeIndex = window.location.href.split("#")[1];
    //根据用户状态判断默认显示的页面
    // this.routeHop('/testregistration');
    // this.reload();
  },

  methods: {
    routeHop(url) {
      this.$router.push(url);
      this.activeIndex == 0;
    },
  },
};
</script>

<style scoped>
.sill-t {
  width: 1px;
  height: 30px;
  background-color: rgb(239, 232, 232);
  margin-top: 10px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(239, 232, 232);
  margin: 20px 0px;
}

.applyicon-fontsize {
  font-size: 25px;
}

.icon-fontsize {
  font-size: 20px;
  margin-right: 3px;
}

.title-fontsize {
  font-size: 20px;
  height: 60px;
}

.line-messages {
  margin-top: 20px;
}

.line-message {
  margin-top: 60px;
}

.message-input {
  width: 300px;
}

.message {
  color: rgb(145, 135, 135);
  width: 80px;
  font-size: 16px;
  font-weight: 300;
}

.detail-linehead {
  line-height: 20px;
  letter-spacing: 1px;
}

.bule-detail {
  color: #ea5374;
  font-weight: 300;
}

.photo-detail-red {
  color: red;
  font-weight: 300;
}

.explain {
  margin-top: 20px;
}

.photo-detail {
  color: rgb(145, 135, 135);
  font-weight: 300;
  margin-top: 10px;
}

.photo-re {
  font-size: 10px;
  font-weight: 500;
}

.photo-requirements {
  margin-left: 60px;
}

.person-profile {
  margin-top: 70px;
}

.two-menu {
  margin-top: 30px;
  font-weight: 500;
}

.notice {
  margin: 0px 30px;
  color: #539fea;
  font-weight: 600;
  font-size: 19px;
}

.off {
  color: #539fea;
  font-size: 18px;
}

.two-icon {
  margin: 20px 40px;
}

.load-nows {
  color: #539fea;
  border: none;
  font-size: 16px;
}

.load-now {
  margin-right: 30px;
  margin-top: 15px;
  color: #000;
}

.register {
  font-size: 20px;
  margin-top: 60px;
}

.con-register {
  width: 100%;
  min-height: 450px;
  background-color: rgb(250, 250, 250);
  padding-bottom: 20px;
}

.title-img {
  width: 40px;
  height: 40px;
  margin: 10px 20px 10px 50px;
  border-radius: 30px;
}

.re-bigbox {
  background-color: #f0f1f1;
  width: 80%;
  height: 900px;
  min-width: 800px;
  margin-top: 40px;
  border-radius: 10px;
}

.re-title {
  height: 10%;
  font-size: 18px;
  font-weight: 500;
  color: #539fea;
}

.el-main {
  display: block;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;
  padding: 0;
}
</style>
